var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PFixTradingWebhookListRequest extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_TRADING_WEBHOOK_LIST_REQUEST, fieldSet);
    }
    static sendMessageAsync(sendMessageAsync, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const pfixMessage = new PFixTradingWebhookListRequest();
            const result = yield sendMessageAsync(pfixMessage, true);
            if (result !== null && result.Code === Message.CODE_TRADING_WEBHOOK_LIST_RESPONSE) {
                return result;
            }
            else {
                return null;
            }
        });
    }
}
